<template>
  <div id="app">
    <HeaderComponent v-if="!$route.meta.hideComponents" />
    <Transition mode="out-in" name="page">
      <RouterView :key="$route.fullPath" />
    </Transition>
    <ModalsComponent />
    <Notifications position="bottom right" />
  </div>
</template>

<script>
import HeaderComponent from "./components/header";
import ModalsComponent from "./components/modals";
import DEPARTMENT from "@/graphql/queries/department_DO_NOT_EDIT.graphql";

export default {
  name: "App",
  created() {
    this.$apollo
      .query({
        query: DEPARTMENT,
      })
      .then(({ data }) => {
        if (data && data.department) {
          this.$store.state.department = data.department;
        }
      });
  },
  // mounted() {
  //   let timeoutId;
  //
  //   document.addEventListener(
  //     "mousemove",
  //     () => {
  //       if (timeoutId) clearTimeout(timeoutId);
  //
  //       timeoutId = setTimeout(() => {
  //         Vue.$cookies.remove("admin-token");
  //         location.reload();
  //       }, 600000); // 10 minutes (600000 miliseconds)
  //     },
  //     false
  //   );
  // },
  components: {
    ModalsComponent,
    HeaderComponent,
  },
};
</script>
